import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { useExpertiseId } from "../../../../context/EcpertiseContext";
import { motion } from "motion/react";
import { fadeInAnimation } from "../../../animation/motionAnimation";

const ExpertiseSection = ({ title, para, id }) => {
  const { expertiseId, setExpertiseId } = useExpertiseId();

  const { ref, inView, entry } = useInView({
    threshold: 0.5,
  });

  useEffect(() => {
    if (inView) {
      setExpertiseId(entry?.target?.id);
    }
  }, [inView]);
  return (
    <div ref={ref} className="py-10" id={id}>
      <div className="overflow-hidden">
        <motion.h2 {...fadeInAnimation} className="text-3xl font-bold my-4">
          {" "}
          {title}
        </motion.h2>
      </div>

      <p className="my-4 text-xl text-mute-grey">{para}</p>
    </div>
  );
};

export default ExpertiseSection;
